import React, { useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { useCompany } from "@/context/CompanyContext";
import { toast } from "sonner";

/** Firmen-Schalter: 2FA-Pflicht für Owner & Treuhänder (Viewer ausgenommen). Nur Owner darf ändern. */
export const CompanyRequire2faToggle = () => {
  const { company, setCompany } = useCompany();
  const [busy, setBusy] = useState(false);
  if (!company) return null;
  const isOwner = company.current_user_role === "owner";
  const enabled = !!company.require_2fa;

  const toggle = async () => {
    setBusy(true);
    try {
      const res = await apiClient.put(`/my/companies/${company._id}`, { require_2fa: !enabled });
      setCompany({ ...company, ...res.data, require_2fa: !enabled });
      toast.success(!enabled ? "2FA-Pflicht aktiviert – Owner und Treuhänder ohne 2FA werden beim nächsten Zugriff zur Einrichtung aufgefordert." : "2FA-Pflicht deaktiviert");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Änderung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-4 pt-4 border-t border-slate-100 flex items-start justify-between gap-4" data-testid="company-require-2fa">
      <div>
        <div className="text-sm font-medium text-slate-900">2FA-Pflicht für diese Firma</div>
        <p className="text-xs text-slate-500 mt-0.5">
          Owner und Treuhänder (Advisor) müssen 2FA aktiviert haben, um auf Buchhaltungsdaten zuzugreifen – auch beim Code-Login.
          Leser (Viewer) sind ausgenommen. {!isOwner && "Nur der Owner kann diese Einstellung ändern."}
        </p>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        disabled={!isOwner || busy}
        onClick={toggle}
        data-testid="company-require-2fa-toggle"
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${enabled ? "bg-indigo-600" : "bg-slate-300"}`}
      >
        <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${enabled ? "translate-x-5" : "translate-x-0.5"}`} />
      </button>
    </div>
  );
};

export default CompanyRequire2faToggle;
